import { isEmpty } from "lodash";

const days_en:string[] = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const days_tr:string[] = ["Pts", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
const months_en:string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const months_tr:string[] = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Agu", "Eyl", "Eki", "Kas", "Ara"];


const getLocalDateTime = ( isEnd:boolean = false ) => {

    let localDateTime = (new Date()).toJSON();
    
    try {

        if ( isEnd ) return `${getDate(localDateTime)}T23:59:59Z`;
        return `${getDate(localDateTime)}T00:00:00Z`;

    } catch (e) {  }
    
}

const getDate = ( dateTime?:string ) => {

    if ( dateTime ) {
        let val = dateTime.split("T");
        return val[0];
    }

}

const _getTime = ( dateTime?:string ) => {

    if ( dateTime ) {
        let val = dateTime.split("T");
        return val[1];
    }

}

const dateTimeToHumanReadable = ( datetime:string|null|undefined, languageISOCode:string|null|undefined = "en" ):string|null => {

    if ( !isEmpty(datetime) && datetime ) {
        try {
            let _datetime = new Date(Date.parse(datetime)).toDateString().split(" ");
            if ( languageISOCode === "tr" ) {
                let day:string = days_tr[days_en.indexOf(_datetime[0])];
                let month:string = months_tr[months_en.indexOf(_datetime[1])];

                return `${_datetime[2]} ${month} ${_datetime[3]}, ${day}`;
            } 
            return `${_datetime[1]} ${_datetime[2]}, ${_datetime[3]}`;
        }
        catch {
            return null;
        }
    }

    return null;

}

const currentDateTimeToHumanReadable = ( languageISOCode:string|null|undefined = "en" ):string|null => {

    try {
        let _datetime = new Date().toDateString().split(" ");
        if ( languageISOCode === "tr" ) {
            let day:string = days_tr[days_en.indexOf(_datetime[0])];
            let month:string = months_tr[months_en.indexOf(_datetime[1])];

            return `${_datetime[2]} ${month} ${_datetime[3]}, ${day}`;
        } 
        return `${_datetime[1]} ${_datetime[2]}, ${_datetime[3]}`;
    }
    catch {
        return null;
    }

}

export {

    getLocalDateTime,
    getDate,
    dateTimeToHumanReadable,
    currentDateTimeToHumanReadable

}